module.exports = __webpack_public_path__ + "img/id.44fa24da.png";